import { render, staticRenderFns } from "./DetalleFacturacion.vue?vue&type=template&id=48b089ae&scoped=true&"
import script from "./DetalleFacturacion.vue?vue&type=script&lang=js&"
export * from "./DetalleFacturacion.vue?vue&type=script&lang=js&"
import style0 from "./DetalleFacturacion.vue?vue&type=style&index=0&id=48b089ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b089ae",
  null
  
)

export default component.exports